import React from 'react';
import {loaderSVG, ArrowBackHoc, EventWaitingHoc, CreateGroupHoc, InfoHoc, FloatingCallVideoHoc, FloatingCallAudioHoc } from '../../../assets/images';
import { NO_SEARCH_CONTACT_FOUND } from '../../../processENV';
import RecentSearch from '../RecentChatSection/RecentSearch';
import Badge from './Badge';
import { getValidSearchVal, handleFilterBlockedContact, isConnStateEqualTo, capitalizeFirstLetter, blockOfflineMsgAction } from '../../../Helpers/Utility';
import { getContactNameFromRoster, getUserInfoForSearch } from '../../../Helpers/Chat/User';
import {toast} from 'react-toastify';
import { NO_INTERNET } from '../../../Helpers/Constants';
import { getUsersListFromSDK } from '../RecentChatSection/userLists';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import SDK from "../../../SDK";
import { CONNECTION_STATE_CONNECTING, CONNECTION_STATE_CONN_FAILED, CONNECTION_STATE_ERROR_OCCURED } from '../../../Helpers/Chat/Constant';
import { getFromLocalStorageAndDecrypt } from '../../../Helpers/Chat/webChatEncryptDecrypt';
import { getMaxUsersInCall } from '../../../Helpers/Call/Call';
import { store } from '../../../Redux/store';
import { setInitialRoster } from '../../../Redux/feature/rosterDataSlice';
import { formatUserIdToJid } from '../../../Helpers/Chat/ChatHelper';
import Contact from '../../ContactInfo/Contact';

const NewParticipants = (props = {}) => {
    const globalState = useSelector(state => state);
    const { rosterData = {},appOnlineStatus : {isAppOnline}, blockedContact, recentChatItems} = globalState;
    const { handleBackToGroup, newCall = false, handleBackToCallLog, 
    handleBackToRecentChat, typingMessage } = props;
    const [getNewParticipants, setNewParticipants] = React.useState({
        searchValue: '',
        groupMembers: [],
        errorMesage: '',
        inProgress: false,
        participantToAdd: [],
        filteredContacts: [],
        displayUserNames: [],
        loaderStatus: !rosterData?.isFetchingUserList,
        userList: [],
    });

    const { searchValue,
        groupMembers,
        errorMesage,
        inProgress,
        participantToAdd,
        filteredContacts,
        // displayUserNames,
        loaderStatus,
        userList
    } = getNewParticipants;

   const errorMessageListner = (errorMesages) => {
        setNewParticipants({...getNewParticipants,
            errorMesage: errorMesages
        })
    }

    const removeParticipant = (userName) => {
        setNewParticipants({...getNewParticipants,
            errorMesage: '',
            participantToAdd: participantToAdd.filter(function (user) {
                return user.userId !== userName
            })
        });
    }

    const addParticipant = (userName, userInfo) => {
        setNewParticipants({...getNewParticipants,
            errorMesage: '',
            participantToAdd: participantToAdd.concat({
                userId: userName,
                ...userInfo
            })
        });
    }

    const prepareContactToAdd = (userName, userInfo) => {
        const exists = participantToAdd.find(user => user.userId === userName)
        if (!exists) {
            return addParticipant(userName, userInfo);
        }
        return false;
    }

    const prepareContactToRemove = (userName, userInfo) => {
        const exists = participantToAdd.find(user => user.userId === userName)
        if (exists) {
            return removeParticipant(userName);
        }
        return false;
    }

    const contactsSearch = (searchTerm) => {
        const { data } = rosterData;
        if (!data) return [];
        return handleFilterBlockedContact(data).filter((item) => {
            const rosterJid = (item.username) ? item.username : item.jid;
            if (groupMembers.indexOf(rosterJid) > -1) {
                return false
            }

            const regexList = getUserInfoForSearch(item);
            return regexList.find((str) => {
                if (!item.isFriend || !str) return false
                return (str.search(new RegExp(searchTerm, "i")) !== -1)
            });
        });
    }

    const searchFilterList = (searchValues) => {
        const searchedValue = getValidSearchVal(searchValues);
        let searchWith = searchedValue;
        const filteredContactts = contactsSearch(searchWith)
        getUsersListFromSDK(1, searchWith);
        setNewParticipants({...getNewParticipants,
            searchValue: searchedValue,
            errorMesage: '',
            filteredContacts: filteredContactts,
            userList: filteredContactts,
            loaderStatus: false
        });
    }

    /**
    // const getBlobfromUrl = () => {
    //     if (!groupProfileImage) {
    //         return Promise.resolve()
    //     }
    //     return fetch(groupProfileImage).then(r => r.blob())
    // }
    */

    const addUsersInGroup = () => {
        if (inProgress) {
            return
        }
        if (participantToAdd.length < 2) {
            setNewParticipants({...getNewParticipants,
                errorMesage: 'Select minimum of two contacts'
            })
            return
        }else if(participantToAdd.length >= 2){
            addParty();
        }
        if (!isAppOnline) {
            toast.error(NO_INTERNET)
            return
        }
        setNewParticipants({...getNewParticipants,
            inProgress: true
        })
    }

    const addParty = async () => {
        const participantJid = [];
        participantToAdd.map(el => participantJid.push(el.userJid));
        /**
        // const groupImgBlob = await getBlobfromUrl();
        */
        const groupImgBlob = "";
        const result = await SDK.createGroup(typingMessage, participantJid, groupImgBlob || "");
        console.log('createGroup result :>> ', result);
        if (result.statusCode === 200) {
            setNewParticipants({...getNewParticipants,
                inProgress: false,
            })
            handleBackToRecentChat();   
            searchFilterList('');   
        } else {
            // Throw Error
        }
    }

    const handleMakeNewCall = () => {
        if(blockOfflineMsgAction()) return
        const roomName = getFromLocalStorageAndDecrypt('roomName');
        if (roomName) {
            toast.info("Can't place a new call while you're already in a call.");
            return;
        }
        props.handleMakeNewCall(props.newCallType, participantToAdd);
    }

    const handleUserListData = () => {
        let dataArr = [];
        const maxMemberReached = Boolean(participantToAdd.length >= (getMaxUsersInCall() - 1));
        if (userList.length > 0) {
            userList.map((contact) => {
                const { username, userId } = contact
                const contactName = getContactNameFromRoster(contact);
                const updateJid = username || userId
                const isChanged = participantToAdd.findIndex(participant => participant.userId === updateJid)
                let blockedContactArr = blockedContact.data;
                const jid = formatUserIdToJid(updateJid);
                const isBlocked = blockedContactArr.indexOf(jid) > -1;
                dataArr.push(
                    <Contact
                        isBlocked={isBlocked}
                        searchValue={searchValue}
                        contactName={contactName}
                        isChanged={isChanged}
                        maxMemberReached={newCall ? maxMemberReached : ""}
                        errorMessageListner={errorMessageListner}
                        prepareContactToAdd={prepareContactToAdd}
                        prepareContactToRemove={prepareContactToRemove}
                        key={updateJid}
                        roster={contact}
                        {...contact}
                    />
                )
            });
        }
        return dataArr;
    }

    const fetchMoreData = () => {
        if(isAppOnline) {
            let searchWith = getValidSearchVal(searchValue);
            getUsersListFromSDK(Math.ceil((userListArr.length / 20) + 1), searchWith);
        }
    }

    const userListArr = handleUserListData();

    /**
        // React.useEffect(() => {
        //     if(messageType === "receiveMessage"){
        //         const fromUser = vCardData?.data?.fromuser;
        //         if (sendfrom.indexOf(fromUser) > -1 && messageBody === '2') {
        //             getBlobfromUrl().then(groupProfileImage => {
        //                 if (groupProfileImage === "" || groupProfileImage === null ||
        //                  groupProfileImage === undefined) {
        //                     groupProfileImage = "";
        //                 }
        //                 // SDK.setGroupInfo(groupId, typingMessage, groupProfileImage, () => {
        //                 //     participantToAdd.forEach(({ userId }) => {
        //                 //         const jid = userId + "@" + REACT_APP_XMPP_SOCKET_HOST;
        //                 //         SDK.groupAddMember(groupId, typingMessage, jid)
        //                 //     })
        //                 //     setNewParticipants({...getNewParticipants,
        //                 //         inProgress: false
        //                 //     }, () => {
        //                 //         handleBackToRecentChat()
        //                 //     })
        //                 // })
        //             }).catch(err => {
        //                 console.log(err, 'error in groupcreation')
        //             })
        //         }
        //     }
        // },[messageData?.id, messageData?.data?.MessageType]);
    
        // React.useEffect(() => {
        //         let newSelectedParticipant = participantToAdd.map(ele => {
        //             let foundRoster = rosterData?.data?.find(el => el.userId === ele.userId);
        //             if (!foundRoster?.isAdminBlocked && !foundRoster?.isDeletedUser) return ele;
        //         });
        //         newSelectedParticipant = newSelectedParticipant.filter(function (element) {
        //             return element !== undefined;
        //         });
        //         const filtered_Contacts = contactsSearch(searchValue);
        //         setNewParticipants({...getNewParticipants,
        //             participantToAdd: newSelectedParticipant,
        //             loaderStatus: rosterData?.isFetchingUserList,
        //             filteredContacts: filtered_Contacts,
        //             userList: filtered_Contacts
        //         });
        // },[rosterData?.id]);
    
        // React.useEffect(() => {
        //     if(!rosterData?.initialRosterFetched){
        //         getUsersListFromSDK(1)
        //     //     let data = (rosterData && rosterData.data) || []
        //     //     setNewParticipants({...getNewParticipants,
        //     //     userList: data, loaderStatus: rosterData?.isFetchingUserList,
        //     // })            
        // }            
        // },[]);

        // React.useEffect(() => {
        //     let data = (rosterData && rosterData.data) || []
        //     setNewParticipants({...getNewParticipants,
        //     userList: data, loaderStatus: rosterData?.isFetchingUserList,
        // })
        // },[rosterData]);
        */
    const handleUpdateRoster = (rosterDataUpdate, isFetchingUserList = false) => {
        let searchWithUpdate = getNewParticipants.searchValue;
        let filteredData = handleFilterBlockedContact(rosterDataUpdate).filter(function (item) {
            let filterVariable = getContactNameFromRoster(item) || item.userId;
            return (item.isFriend) && filterVariable.toLowerCase().search(searchWithUpdate.toLowerCase()) !== -1;
        });
        let data = filteredData
        setNewParticipants({ ...getNewParticipants, filterItem: data, userList: data, loaderStatus: isFetchingUserList });
    }

    React.useEffect(()=>{
        getUsersListFromSDK(1,"")
        store.dispatch(setInitialRoster())
    },[])

    React.useEffect(() => {
        let data = (rosterData && rosterData.data) || []
        if(!rosterData?.initialRosterFetched || !rosterData?.isFetchingUserList){
            getUsersListFromSDK(1,"")
            handleUpdateRoster(data, rosterData?.isFetchingUserList);
        }
    }, [])

    React.useEffect(() => {
        
        fetchMoreData();
        
    }, [isAppOnline])

    React.useEffect(() => {
            handleUpdateRoster(rosterData.data, rosterData?.isFetchingUserList);
    }, [rosterData, recentChatItems])

    React.useEffect(() => {
        return(
            searchFilterList('')
        )
    },[])
    
    return (
        <React.Fragment>
            <div>
                <div className="contactlist">
                    <div className="recent-chatlist-header">
                        <div className="profile-img-name">
                            {
                                !inProgress && <i className="newchat-icon" onClick={newCall ? handleBackToCallLog : handleBackToGroup} title="Back">
                                    <ArrowBackHoc  viewBox="0 0 24 24"/>
                                </i>
                            }
                            <span>{newCall ? "Contacts" : "Add Group Participants"}</span>
                            {!newCall &&
                                <i onClick={addUsersInGroup} className={inProgress ? 'createGroup-loader' : 'createGroup-icon'} title="Create group">
                                    {inProgress ? <EventWaitingHoc /> : <CreateGroupHoc viewBox="0 0 4.266 7.11"/>}
                                </i>}
                        </div>
                    </div>

                    <RecentSearch search={searchFilterList} />
                    {searchValue && userListArr.length <= 0 && !loaderStatus && filteredContacts &&
                        <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/> {NO_SEARCH_CONTACT_FOUND}</span>
                    }
                    
                    {(!isAppOnline ||
                        isConnStateEqualTo([
                            CONNECTION_STATE_CONNECTING,
                            CONNECTION_STATE_CONN_FAILED,
                            CONNECTION_STATE_ERROR_OCCURED,
                        ])) && (                                
                            <div className="networkoffline">
                            {!isAppOnline
                                ? "Please check your Internet connection"
                                : capitalizeFirstLetter(
                                CONNECTION_STATE_CONNECTING.toLocaleLowerCase()
                                )}
                            </div>
                        )
                    }
                    {errorMesage && <div className="errorMesage"><InfoHoc viewBox="0 0 8.683 8.683"/><span>{errorMesage}</span></div>}
                    {userListArr.length > 0 ? 
                        <ul className={`chat-list-ul ${
                            (!isAppOnline ||
                                isConnStateEqualTo([
                                    CONNECTION_STATE_CONNECTING,
                                    CONNECTION_STATE_CONN_FAILED,
                                    CONNECTION_STATE_ERROR_OCCURED,
                                ])) ? " offline " : "" } newGroup ${(newCall && participantToAdd.length > 0) ? "adjustHeight" : "" }`} id="scrollableUl-group">
                            <li className="chat-list-li BadgeContainer">
                                <div className="selectedBadge">
                                    <ul>
                                        {participantToAdd.map(participant => {
                                            const { userId } = participant
                                            /**
                                            // let blockedContactArr = blockedContact.data;
                                            // const jid = formatUserIdToJid(userId);
                                            // const isBlocked = blockedContactArr.indexOf(jid) > -1;
                                            */
                                            return <Badge
                                                key={userId}
                                                {...participant}
                                                // isBlocked={isBlocked}
                                                removeParticipant={removeParticipant}
                                            />
                                        })}
                                    </ul>
                                </div>
                            </li>
                            <InfiniteScroll
                                dataLength={userListArr.length}
                                next={fetchMoreData}
                                hasMore={true}
                                scrollableTarget="scrollableUl-group"
                            >
                                {handleUserListData()}
                            </InfiniteScroll>
                        </ul>
                        :
                        <div className='' style={{"flex" : "1"}}></div>
                    }
                    {loaderStatus && isAppOnline && <div className="loader-container style-2">
                        <img src={loaderSVG} alt="loader" />
                    </div>}
                    {newCall && participantToAdd.length > 0 &&
                        <div onClick={handleMakeNewCall} className="callButton">
                            <i> {props.newCallType === "video" ? <FloatingCallVideoHoc  viewBox="0 0 20.013 12.205"/> : <FloatingCallAudioHoc viewBox="0 0 20 20" />}</i> Call now ({participantToAdd.length})
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

export default NewParticipants;
